import * as productActions from '../Category/Product/actions/productActions'


export const categoryUpdateSuccess = () => {
    return {
        type : 'CATEGORY_UPDATE_SUCCES'
    }
}
export const categoryUpdateFail = ()=> {
    return {
        type : 'CATEGORY_UPDATE_FAIL'
    }
}
export const mainCategoryAddFail = (e) => {
    return {
        type : 'MAIN_CATEGORY_ADD_FAIL',
        payload : {
            e
        }
    }
}
export const mainCategoryAddSuccess = () => {
    return {
        type : 'MAIN_CATEGORY_ADD_SUCCESS'
    }
}

export const addNewMainCategory = (text) => {
    return (dispatch, getState, getFirebase) => {
        const mainCategoryLength = getState().category.mainCategory === undefined ? 0 : getState().category.mainCategory.length;

        const firebase = getFirebase();
        const categoryRef = firebase.ref().child(`category/mainCategory`);
        const newCategoryRef = categoryRef.push();
        newCategoryRef.set(text, () => {
            console.log('main category add success');
        })
            .catch(e => {
                dispatch(mainCategoryAddFail(e))
            })
    }
}

export const removeMainCategory = (id) => {
    return (dispatch, getState, getFirebase) => {
        const result = global.confirm('정말로 삭제하시겠습니까?');
        if(result) {
            const firebase = getFirebase();
            const category = getState().category;
            const mainIndex = category.mainCategory.findIndex((main) => {
                return main.id === id
            });

            const subCategoryRef = firebase.ref().child(`category/subCategory/${id}`);
            subCategoryRef.remove()
                .then(() => {
                    const mainCategoryRef = firebase.ref().child(`category/mainCategory/${id}`);
                    mainCategoryRef.remove()
                        .then(() => {
                            const products = getState().products;
                            products.map(product => {
                                if (product.category.mainCategory === mainIndex) {
                                    const productCategoryRef = firebase.ref().child(`products/${product.id}/category`);
                                    productCategoryRef.update({
                                        'mainCategory': -1,
                                        'subCategory': -1
                                    }, () => {
                                    })
                                        .catch(e => {
                                            console.log(e);
                                        })
                                } else if(product.category.mainCategory > mainIndex) {
                                    const productCategoryRef = firebase.ref().child(`products/${product.id}/category`);
                                    productCategoryRef.update({
                                        'mainCategory' : mainIndex,
                                    }, () => {
                                    })
                                        .catch(e =>{
                                            console.log(e)
                                        })
                                }
                            })
                        })
                        .catch((e) => {
                            console.log('main category remove fail');
                        })
                })
                .catch(() => {

                })
        }
    }
}

export const removeSubCategory = (mainId, subId) => {
    return (dispatch, getState, getFirebase) => {
        const result = global.confirm('정말로 삭제하시겠습니까?');
        if(result) {
            const category = getState().category;
            const mainIndex = category.mainCategory.findIndex((main) => {
                return main.id === mainId
            });
            const subIndex = category.subCategory[mainIndex].findIndex((sub) => {
                return sub.id === subId
            });

            if(mainIndex === -1 || 
               subIndex === -1) {
                console.log('There is no apropriate category');
                return;
            }

            const firebase = getFirebase();
            const subCategoryRef = firebase.ref().child(`category/subCategory/${mainId}/${subId}`);
            //카테고리에 하나만 있을 때
            if(category.subCategory[mainIndex].length === 1) {
                subCategoryRef.update({
                    'en' : 'New Category',
                    'ko' : '새로운 카테고리',
                    'order' : 0
                })
                const products = getState().products;
                products.map(product => {
                    if(product.category.mainCategory === mainIndex) {
                        if(product.category.subCategory === subIndex) {
                                const productCategoryRef = firebase.ref().child(`products/${product.id}/category`);
                                productCategoryRef.update({
                                    'mainCategory': -1,
                                    'subCategory': -1
                                }, () => {
                                })
                                    .catch(e => {
                                    })
                        }
                    }
                });
            } else {
                subCategoryRef.remove()
                    .then(()=> {
                        const subCategories = getState().category.subCategory[mainIndex];
                        let index = 0;
                        subCategories.map(cat => {
                            if(cat.text.order > subIndex) {
                                const catRef = firebase.ref().child(`category/subCategory/${mainId}/${cat.id}`);
                                catRef.update({
                                    'order' : index 
                                })
                            }
                            index++;
                        })

                        const products = getState().products;
                        let newSubIndexForProduct = 1;
                        products.map(product => {
                            if(product.category.mainCategory === mainIndex) {
                                if(product.category.subCategory === subIndex) {
                                    newSubIndexForProduct = -1;

                                    const productCategoryRef = firebase.ref().child(`products/${product.id}/category`);
                                    productCategoryRef.update({
                                        'mainCategory': -1,
                                        'subCategory': newSubIndexForProduct
                                    }, () => {
                                    })
                                        .catch(e => {
                                        })

                                } else if(product.category.subCategory > subIndex) {
                                    newSubIndexForProduct = product.category.subCategory - 1;

                                    const productCategoryRef = firebase.ref().child(`products/${product.id}/category`);
                                    productCategoryRef.update({
                                        'mainCategory': mainIndex,
                                        'subCategory': newSubIndexForProduct
                                    }, () => {
                                    })
                                        .catch(e => {
                                        })
                                }
                            }
                        })
                    })
                        .catch((e)=>{
                            console.log('sub category remove fail');
                        })
            }
        }
    }
}

export const updateMainCategory = (id, text) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const mainCategoryRef = firebase.ref().child(`category/mainCategory`);
        mainCategoryRef.update({
            [id] : text
        }, ()=> {
            console.log('update success');
        })
            .catch((e)=>{
                console.log(e);
            })
    }
}

export const subCategoryAddSuccess = () => {
    return {
        type : 'SUB_CATEGORY_ADD_SUCCESS'
    }
}
export const subCategoryAddFail = (e) => {
    return {
        type : 'SUB_CATEGORY_ADD_FAIL',
        payload : {
            e
        }
    }
}

export const addSubCategory = (mainId) => {
    return (dispatch, getState, getFirebase) => {

        const category = getState().category;
        const mainIndex = category.mainCategory.findIndex(main => {
            return main.id === mainId;
        })

        const subCategory = getState().category.subCategory;
        let subCategoryLength = 0;
        if(subCategory !== undefined) {
            if(subCategory[mainIndex] !== undefined){
                subCategoryLength = subCategory[mainIndex].length;
            }
        } 

        const firebase = getFirebase();

        const subCategoryRef = firebase.ref().child(`category/subCategory/${mainId}`);
        const newSubCategoryRef = subCategoryRef.push();

        newSubCategoryRef.set( {
                ko : `${mainIndex}_새로운 카테고리_${subCategoryLength}`,
                en : `${mainIndex}_New Category_${subCategoryLength}`,
                order : subCategoryLength
            }, () => {
                dispatch(subCategoryAddSuccess());
            })
            .catch( e=> {
                dispatch(subCategoryAddFail())
            });
    }
}

export const updateSubCategory = (mainId, subId, text) => {
    return (dispatch, getState, getFirebase) => {
        const category = getState().category;
        const mainIndex = category.mainCategory.findIndex((main) => {
            return main.id === mainId
        });
        const subIndex = category.subCategory[mainIndex].findIndex((sub) => {
            return sub.id === subId
        })

        const firebase = getFirebase();
        const subCategoryRef = firebase.ref().child(`category/subCategory/${mainId}`);
        subCategoryRef.update({
            [subId] : text
        }, ()=> {
            console.log('update success');
        })
            .catch((e)=>{
                console.log(e);
            })
    }
}

export const subCategoryOrderSwitch = (aIndex, bIndex, mainIndex) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();

        const dataArray = getState().category.subCategory[mainIndex];
        if(aIndex < 0 || aIndex > dataArray.length - 1 ||
           bIndex < 0 || bIndex > dataArray.length - 1 || 
           dataArray.length === 1) {
            return;
        }

        const mainId = getState().category.mainCategory[mainIndex].id;
        console.log(dataArray);

        let aData = dataArray[aIndex];
        const aId = aData.id;
        delete aData['id'];

        let bData = dataArray[bIndex];
        const bId = bData.id;
        delete bData['id'];

        const newAOrder = bData.text.order;
        const newBOrder = aData.text.order;

        const prevAOrder = aData.text.order;
        const prevBOrder = bData.text.order;

        aData.text.order = newAOrder;
        bData.text.order = newBOrder;

        const aDataRef = firebase.ref().child(`category/subCategory/${mainId}/${aId}`);
        aDataRef.update({
            ...aData.text
        });
        const bDataRef = firebase.ref().child(`category/subCategory/${mainId}/${bId}`);
        bDataRef.update({
            ...bData.text
        });

        const products = getState().products;
        products.map((product, index) => {
            const productRef = firebase.ref().child(`products/${product.id}`);     
            if(product.category.mainCategory === mainIndex) {
                if(product.category.subCategory === prevAOrder) {
                    productRef.update({
                        'category' : {
                            mainCategory : product.category.mainCategory,
                            subCategory : newAOrder
                        }
                    });
                }
                else if(product.category.subCategory === prevBOrder) {
                    productRef.update({
                        'category' : {
                            mainCategory : product.category.mainCategory,
                            subCategory : newBOrder
                        }
                    });
                }
            }
        });
    }
}




// WEBPACK FOOTER //
// ./src/pages/Admin/ProductManager/actions/categoryActions.js